import ArtistApplyHeader from './ArtistApplyHeader'

export default ArtistApplyHeader
